import React, { useState, useEffect } from "react";

import ClubbieModal from "../../../Modal/ClubbieModal";
import ClubbieSelect from "../../../ClubbieSelect/ClubbieSelect";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";

const TEAM_PRESETS = [2, 4, 8, 16, 32, 64, 128];

const LEG_OPTIONS = [
  { value: 1, label: "Single-leg" },
  { value: 2, label: "Two legs" },
];

const BracketModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  mode = "create",
  initialData = { name: "", teamsCount: 2, numberOfLegs: 1 },
  phaseId = "",
}) => {
  const [bracketConfig, setBracketConfig] = useState({
    teamsCount: 2,
    numberOfLegs: 1,
  });

  useEffect(() => {
    if (isOpen) {
      setBracketConfig({
        teamsCount: initialData.teamsCount || 2,
        numberOfLegs: initialData.numberOfLegs || 1,
      });
    }
  }, [isOpen, initialData]);

  const isCreate = mode === "create";

  const handleSubmit = () => {
    onSubmit({
      name: initialData.name || "Bracket",
      teamsCount: parseInt(bracketConfig.teamsCount),
      numberOfLegs: parseInt(bracketConfig.numberOfLegs) || 1,
    });
  };

  const renderFooter = () => (
    <div className="flex justify-end gap-3 w-full">
      <button
        type="button"
        className="px-6 py-3 text-sm font-medium text-app-text bg-app-card rounded-full hover:text-[#FEFCEB] transition-colors cursor-pointer"
        onClick={onClose}
      >
        Cancel
      </button>
      <button
        type="button"
        className="bg-[#00E7FF] hover:bg-[#00cce6] text-[#021529] font-medium px-6 py-3 rounded-full text-sm transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        onClick={handleSubmit}
        disabled={isLoading || !bracketConfig.teamsCount}
      >
        {isLoading ? (
          <>
            <LoadingSpinner size="small" />
            <span>{isCreate ? "Creating..." : "Saving..."}</span>
          </>
        ) : isCreate ? (
          "Create"
        ) : (
          "Save"
        )}
      </button>
    </div>
  );

  return (
    <ClubbieModal
      isOpen={isOpen}
      width="680px"
      maxHeight="90vh"
      toggle={onClose}
      title={`${isCreate ? "Add" : "Edit"} bracket${phaseId ? ` in ${phaseId}` : ""}`}
      footer={renderFooter()}
    >
      <div className="space-y-6">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className="block text-[14px] font-normal text-clubbie-white ">Number of teams</label>
            <div className="flex gap-2">
              <div className="flex gap-2">
                {TEAM_PRESETS.map((n) => (
                  <button
                    key={n}
                    type="button"
                    className={`w-10 h-10 rounded-full text-sm font-medium transition-colors ${
                      bracketConfig.teamsCount === n
                        ? "bg-app-surface  text-light-blue border border-light-blue"
                        : "bg-app-surface text-[#FEFCEB] hover:bg-[#192634]"
                    }`}
                    onClick={() => setBracketConfig((p) => ({ ...p, teamsCount: n }))}
                  >
                    {n}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="block text-[14px] font-normal text-clubbie-white ">Match format</label>
            <ClubbieSelect
              placeholder="Select format"
              options={LEG_OPTIONS}
              value={LEG_OPTIONS.find((o) => o.value === bracketConfig.numberOfLegs) || null}
              onChange={(option) => setBracketConfig((p) => ({ ...p, numberOfLegs: option.value }))}
              getOptionLabel={(o) => o.label}
              getOptionValue={(o) => o.value}
            />
          </div>
        </div>
      </div>
    </ClubbieModal>
  );
};

export default BracketModal;
